<template>
  <v-autocomplete
    v-model="value"
    :items="items"
    item-text="name"
    item-value="key"
    :label="label"
    :disabled="disabled"
    :clearable="clearable"
    :loading="loading"
    return-object
  />
</template>

<script>
import firebase from "firebase";
import VueTypes from "vue-types";
import {deserialize} from "serializr";
import { WorkerKind } from "@/modules/redactor/models/worker/WorkerKind";

export default {
  name: "r-worker-kind-dropdown",
  props: {
    label: VueTypes.string.def("Worker Kind"),
    disabled: VueTypes.bool.def(false),
    clearable: VueTypes.bool.def(true),
    model: VueTypes.instanceOf(WorkerKind)
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
  },
  mounted() {
    this.items = WorkerKind.getValues();
  },
  methods: {
  }
};
</script>